import React, { useState, useEffect } from 'react'
import { CheckIcon } from '@heroicons/react/solid'

import classNames from '@/utils/classNamesLocal'
import useQuery from '@/hooks/useQuery'
import { useGlobalState } from '@/state'
import Loading from '@/shared/Loading'
import { SVGIcon } from '@/components/icon'

// Key matches the user_metas jbuilder.
const KINDS = {
  voiceActor: { image: 'voiceactor', text: 'Voice Actor', to_db: 'voice_actor' },
  liveActor: { image: 'actor', text: 'Actor', to_db: 'live_actor' },
  singer: { image: 'singer', text: 'Singer', to_db: 'singer' },
  artist: { image: 'artist', text: 'Artist', to_db: 'artist' },
  animator: { image: 'animator', text: 'Animator', to_db: 'animator' },
  videoEditor: { image: 'video-editor', text: 'Video Editor', to_db: 'video_editor' },
  musicComposer: { image: 'musiccomposer', text: 'Music Composer', to_db: 'music_composer' },
  audioEngineer: { image: 'audio-engineer', text: 'Audio Engineer', to_db: 'audio_engineer' },
  writer: { image: 'writer', text: 'Writer', to_db: 'writer' },
  director: { image: 'director', text: 'Director', to_db: 'director' },
  agent: { image: 'agent', text: 'Agent', to_db: 'agent' },
  producer: { image: 'producer', text: 'Producer', to_db: 'producer' }
}

// Toggle chips. Each click saves on its own, so there is no Save button.
const ProfileCreatorKinds = () => {
  const { getRequest, putpostRequest } = useQuery()
  const [user, setUser] = useGlobalState('userContainerUser')
  const [meta, setMeta] = useState(null)
  const [saving, setSaving] = useState(null)

  useEffect(() => {
    getRequest('/api/v3/user_metas', {}, (err, jsonData) => {
      if (err) { return }
      setMeta(jsonData.userMeta || {})
    })
  }, [])

  const toggle = (key) => {
    const next = !meta[key]
    setSaving(key)
    putpostRequest('/api/v3/user_metas/update_meta', 'POST', { user_meta: { [KINDS[key].to_db]: next } }, (err) => {
      setSaving(null)
      if (err) { return }
      const updated = { ...meta, [key]: next }
      setMeta(updated)
      setUser({ ...user, creatorKindsCount: Object.keys(KINDS).filter((k) => updated[k]).length })
    })
  }

  return <div className='md:grid md:grid-cols-4 md:gap-6'>
    <div className='mb-4 md:mb-0'>
      <h3 className='text-lg font-semibold text-gray-900 dark:text-gray-100'>What do you do?</h3>
      <p className='mt-1 text-sm text-gray-600 dark:text-gray-300'>Pick everything that applies. This is how people find you in talent search.</p>
    </div>
    <div className='rounded-xl bg-white p-4 shadow-sm dark:bg-gray-800 md:col-span-3'>
      { !meta && <Loading /> }
      { meta && <div className='flex flex-wrap gap-2'>
        { Object.keys(KINDS).map((key) => {
          const on = !!meta[key]
          return <button key={key} type='button' onClick={() => toggle(key)} aria-pressed={on} disabled={saving === key}
            className={classNames('inline-flex items-center gap-x-1.5 rounded-full py-1 pl-1.5 pr-3 text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-cccblue disabled:opacity-60',
              on ? 'bg-cccorange text-white' : 'bg-white text-gray-700 ring-1 ring-gray-200 hover:ring-cccorange hover:text-cccorange dark:bg-gray-700 dark:text-gray-100 dark:ring-gray-600')}>
            <SVGIcon name={KINDS[key].image} width='28' height='28' autoDark />
            {KINDS[key].text}
            { on && <CheckIcon className='h-4 w-4' /> }
          </button>
        })}
      </div> }
    </div>
  </div>
}

export default ProfileCreatorKinds
